import React from 'react'
import i18n from 'atpjs/helpers/i18n'
const t = i18n.prefix(['components', 'appointmentGrid'])

const NoEvents = () => {
  return (
    <div className="atp-notification">
      <p>{t(['availableEvents'])}</p>
      <p>{t(['checkNextWeek'])}</p>
    </div>
  )
}

export default NoEvents
